import { nameof } from "@libs/utils/name-of.utils.ts";
import { required } from "@libs/validation/fieldValidators.ts";
import { ClaimAdjustmentDocumentFormValue } from "@shared-types/acc/claim-adjustment-document-value.type.ts";

import { DocumentFormValidatorBase } from "./DocumentFormValidatorBase.tsx";

export class DocumentFormValidator extends DocumentFormValidatorBase<ClaimAdjustmentDocumentFormValue> {
  constructor() {
    super();
    this.forField(nameof("fileName"), required());
  }
}
